import { render } from "./ArticlesLine.vue?vue&type=template&id=456184df&lang=pug"
import script from "./ArticlesLine.vue?vue&type=script&lang=ts"
export * from "./ArticlesLine.vue?vue&type=script&lang=ts"

import "./ArticlesLine.vue?vue&type=style&index=0&id=456184df&lang=scss"
script.render = render

export default script